<template>
	<v-container>
		<v-row>
			<v-col cols="12">
				<v-breadcrumbs :items="breadcrumbs">
					<template #divider>
						<v-icon>mdi-chevron-left</v-icon>
					</template>
				</v-breadcrumbs>
			</v-col>
		</v-row>
		
		<v-row justify="center">
			<v-col cols="12">
				<v-card class="text-center">
					<v-form v-if="rules" ref="addNewUserForm" v-model="valid" :disabled="loading">
						<v-row justify="center" class="px-8">
							<v-col cols="12">
								<h3>انشاء حساب جديد</h3>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="fullName"
									outlined
									hide-details="auto"
									label="الاسم"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>
							<v-col>
								<v-autocomplete
									v-model="specialties"
									:items="allSpecialties"
									item-text="name"
									item-value="id"
									label="التخصص"
									outlined
									hide-details
								>
									<template #item="{ item }">
										<v-list-item-content>
											<v-list-item-title>
												{{ item.name }}
											</v-list-item-title>
											<v-list-item-subtitle v-if="item.femName" class="text-caption">
												{{ item.femName }}
											</v-list-item-subtitle>
										</v-list-item-content>
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="displayName"
									outlined
									hide-details="auto"
									label="اسم العرض"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="6">
								<v-text-field
									v-model="password"
									outlined
									hide-details="auto"
									label="كلمة المرور"
									:rules="[rules.required, rules.password]"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="6">
								<v-text-field
									v-model="password_confirmation"
									outlined
									hide-details="auto"
									label="تأكيد كلمة المرور"
									:rules="[rules.required, rules.password]"
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="email"
									outlined
									hide-details="auto"
									label="البريد الإلكتروني"
									:rules="[rules.required, rules.email]"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="6">
								<v-text-field
									v-model="phoneNumber"
									outlined
									hide-details="auto"
									label="رقم الجوال"
									dir="ltr"
									placeholder="+9665XXXXXXXX"
									:rules="[rules.required, rules.mobile]"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="6">
								<v-select
									v-model="gender"
									outlined
									hide-details="auto"
									label="الجنس"
									:items="genders"
									item-text="name"
									item-value="value"
								></v-select>
							</v-col>
							<v-col v-if="errors.length" cols="12">
								<v-alert color="error" dark class="text-start">
									<ul>
										<li v-for="error in errors" :key="error">{{ error }}</li>
									</ul>
								</v-alert>
							</v-col>
							<v-col cols="12" @mouseover="validateAddNewUser">
								<v-btn class="primary" large :disabled="!valid" :loading="loading" @click="signup">
									مستخدم جديد
									<v-icon right>mdi-account-plus</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";

export default {
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{ text: 'الرئيسية', to: { name: "home" }, exact: true },
				{ text: 'انشاء حساب جديد', disabled: true }
			],
			genders: [
				{
					name: "-",
					value: null
				},
				{
					name: "ذكر",
					value: "M"
				},
				{
					name: "انثى",
					value: "F"
				}
			],
			fullName: null,
			displayName: null,
			email: null,
			phoneNumber: "+9665",
			gender: null,
			password: null,
			password_confirmation: null,
			valid: false,
			loading: false,
			errors: [],
			specialties: null,
			allSpecialties: [],
		};
	},
	mounted() {
		this.getSpecialties();
	},
	methods: {
		validateAddNewUser() {
			this.$refs.addNewUserForm.validate();
		},
		signup() {
			this.loading = true;
			this.errors = [];

			let config = {
				headers: {
					"Content-Type": "multipart/form-data; boundary=something"
				}
			};

			let data = new FormData();

			data.append("fullName", this.fullName);
			data.append("displayName", this.displayName);
			data.append("email", this.email);
			data.append("phoneNumber", this.phoneNumber);
			data.append("gender", this.gender);
			data.append("password", this.password);
			data.append("password_confirmation", this.password_confirmation);
			data.append("specialties", this.specialties);

			client
				.post("/api/users/signup", data, config)
				.then(response => {
					console.log(response);
					this.$store.dispatch("notify", {
						message: "تم انشاء الحساب بنجاح"
					});
					this.loading = false;
					this.$router.push({ name: "home" });
				})
				.catch(err => {
					var errors = err.response.data.errors;
					const ERROR_TAKEN_DISPLAY_NAME =
						"The display name has already been taken.";
					const ERROR_TAKEN_EMAIL =
						"The email has already been taken.";
					const ERROR_TAKEN_PHONE =
						"The phone number has already been taken.";

					if (errors.displayName[0] == ERROR_TAKEN_DISPLAY_NAME) {
						this.errors.push(
							"اسم العرض مستخدم, الرجاء اختيار اسم عرض اخر"
						);
					}

					if (errors.email[0] == ERROR_TAKEN_EMAIL) {
						this.errors.push(
							"البريد الإلكتروني مستخدم مسبقا, تاكد من حال وجود حساب لك"
						);
					}

					if (errors.phoneNumber[0] == ERROR_TAKEN_PHONE) {
						this.errors.push(
							"رقم الجوال مستخدم مسبقا, تاكد من حال وجود حساب لك"
						);
					}

					this.$store.dispatch("notify", {
						message: "فشلت عملية التسجيل",
						color: "error",
					});
					this.loading = false;
				});
		},
		getSpecialties() {
			client
				.get("/api/specialties/all")
				.then(response => {
					this.allSpecialties = response.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
	}
};
</script>